import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React from "react";

// Get Stripe publishable key from environment
const publishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// Only initialize Stripe if we have a valid key
const stripePromise = publishableKey ? loadStripe(publishableKey) : null;

interface StripeProviderProps {
	children: React.ReactNode;
}

export const StripeProvider: React.FC<StripeProviderProps> = ({ children }) => {
	if (!publishableKey || !stripePromise) {
		console.error(
			"VITE_STRIPE_PUBLISHABLE_KEY is missing from environment variables",
		);
		return (
			<div
				style={{
					padding: "20px",
					color: "red",
					background: "#fee",
					borderRadius: "8px",
					margin: "20px",
				}}
			>
				<strong>Stripe Configuration Error</strong>
				<p>
					Stripe publishable key not found. Please check your environment
					variables.
				</p>
				<p>
					Required: <code>VITE_STRIPE_PUBLISHABLE_KEY</code>
				</p>
			</div>
		);
	}

	return <Elements stripe={stripePromise}>{children}</Elements>;
};
